/**
 * Extracts the TRPCError code (e.g. 'NOT_FOUND', 'FORBIDDEN') from an
 * unknown error-like value, or '' if absent. Shared by every error→copy mapper
 * (`mapOrderError`, `mapAuthError`) and by callers that need to branch on a
 * specific code (e.g. OrderDetailPage's NOT_FOUND → friendly empty state).
 */
export const getErrorCode = (err: unknown): string =>
  err !== null &&
  typeof err === 'object' &&
  'data' in err &&
  (err as { data: unknown }).data !== null &&
  typeof (err as { data: unknown }).data === 'object' &&
  'code' in (err as { data: object }).data &&
  typeof (err as { data: { code: unknown } }).data.code === 'string'
    ? (err as { data: { code: string } }).data.code
    : ''
